import type { TimingEngine } from './timing-engine';

export interface ScrollControllerOptions {
  smoothing?: number;
}

const DEFAULT_SMOOTHING = 0.15;

export class ScrollController {
  private rafId: number | null = null;
  private currentScrollY = 0;
  private readonly smoothing: number;

  constructor(
    private timingEngine: TimingEngine,
    private timeProvider: () => number,
    private scrollTo: (y: number) => void,
    private getViewportOffset: () => number,
    options?: ScrollControllerOptions,
  ) {
    this.smoothing = options?.smoothing ?? DEFAULT_SMOOTHING;
  }

  get isRunning(): boolean {
    return this.rafId !== null;
  }

  start(): void {
    if (this.rafId !== null) return;
    this.tick();
  }

  stop(): void {
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }

  destroy(): void {
    this.stop();
  }

  private tick = (): void => {
    const timeMs = this.timeProvider();
    const { scrollY } = this.timingEngine.getScrollPosition(timeMs);
    const targetScrollY = scrollY - this.getViewportOffset();

    this.currentScrollY += (targetScrollY - this.currentScrollY) * this.smoothing;
    this.scrollTo(this.currentScrollY);

    this.rafId = requestAnimationFrame(this.tick);
  };
}
